<template>
	<div id="portfolio">
		<div class="container-fluid p-0">
			<div class="row g-0">
				<div v-for="(item, key) in works" :key="key" class="col-lg-4 col-sm-6 app">
					<router-link append :to="assembly[key]" class="portfolio-box" :title="item[1]">
						<img class="img-fluid" :src="require('../assets/ProjectPicture/' + key + '.' + item[2])"
							alt="..." />
						<div class="portfolio-box-caption">
							<div class="project-category text-white-50">{{ item[0] }}</div>
							<div class="project-name">{{ item[1] }}</div>
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import works from "../data/data.json";
	export default {
		name: "Apple",
		data() {
			return {
				works: works.works,
				assembly: works.app,
			};
		},
	};
</script>

<style scoped>
	#portfolio {
		padding-top: 62px;
		min-height: 100vh;
	}
	@media screen and (max-width: 922px) {
		#portfolio {
			padding-top: 72px;
		}
	}
	.app {
		cursor: pointer;
	}

	@media screen and (max-width: 574px) {
		#portfolio .container-fluid .portfolio-box .portfolio-box-caption {
			opacity: 1;
		}
	}
</style>
